import dreamlinestudios1 from '../images/work/dreamlinestudios1.png';
import fahrenheit1 from '../images/work/fahrenheit1.png';
import sovos2 from '../images/work/sovos2.png';
import wlion1 from '../images/work/wlion1.png';
import nicholaspsmith1 from '../images/work/nicholaspsmith1.png';

export default [
    {
        name: 'Dreamline Studios',
        info: 'Founder & Principal Engineer',
        img: dreamlinestudios1,
        alt: 'Dreamline Studios',
        viewLink: "https://dreamlinestudios.com/"
    },
    {
        name: 'Sovos',
        info: 'Software Engineer III',
        img: sovos2,
        alt: 'Sovos',
        viewLink: "https://sovos.com/"
    },
    {
        name: 'NicholasPSmith.com',
        info: 'Software Developer',
        img: nicholaspsmith1,
        alt: 'Nicholaspsmith',
        viewLink: "https://nicholaspsmith.com/"
    },
    {
        name: 'Fahrenheit',
        info: 'Front End Developer',
        img: fahrenheit1,
        alt: 'Fahrenheit',
        viewLink: "https://fahrenheit.io/"
    },
    {
        name: 'White Lion',
        info: 'Web Developer',
        img: wlion1,
        alt: 'Fahrenheit',
        viewLink: "https://wlion.com/"
    },
];


// WEBPACK FOOTER //
// ./src/assets/data/job_data.js